import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Curtains from "@/components/Curtains";

export default function CurtainTransition() {
  const location = useLocation();
  const [seenKey, setSeenKey] = useState(null);
  const [phase, setPhase] = useState("idle");

  if (location.state?.curtain && seenKey !== location.key) {
    setSeenKey(location.key);
    setPhase("closed");
  }

  useEffect(() => {
    if (!seenKey) return undefined;
    window.history.replaceState({}, "");
    const openT = setTimeout(() => setPhase("open"), 200);
    const doneT = setTimeout(() => {
      setPhase("idle");
      document.documentElement.classList.remove("stage");
    }, 2300);
    return () => {
      clearTimeout(openT);
      clearTimeout(doneT);
    };
  }, [seenKey]);

  if (phase === "idle") return null;
  return (
    <div data-testid="curtain-transition" className="fixed inset-0 z-[200] pointer-events-none">
      <Curtains open={phase === "open"} heart appear={false} duration={1.8} className="!bg-transparent" />
    </div>
  );
}
